import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import {
    Row, Col, Alert, Select, Button, Input, Radio, DatePicker, TimePicker,
    InputNumber, Checkbox, Icon
} from 'antd'
import IssueUploadA from './IssueUploadA'
import IssueUploadB from './IssueUploadB'
import IssueUploadC from './IssueUploadC'
import IssueUploadD from './IssueUploadD'
import moment from 'moment'
import ol from 'openlayers'
import 'openlayers/dist/ol.css'

const Option = Select.Option
const RadioGroup = Radio.Group
const { TextArea } = Input
const dateFormat = 'YYYY/MM/DD'
const format = 'HH:mm'

class AdminIssuesForm extends Component {

    constructor(props) {
        super(props)
        this.updateForm = this.updateForm.bind(this)
        this.state = Object.assign({}, this.props.data)
        this.onChangeAddress = this.onChangeAddress.bind(this)
        this.renderMap = this.renderMap.bind(this)

        // Init map
        this.map = new ol.Map({
            target: null,
            renderer: 'canvas',
            layers: [
                new ol.layer.Tile({
                    id: 'base',
                    name: 'OSM',
                    visible: true,
                    source: new ol.source.OSM()
                })
            ],
            view: new ol.View({
                center: this.state.mapCenter,
                zoom: this.state.mapZoom
            })
        })

        // Register events
        this.map.on('moveend', () => {
            this.props.changeMapCenter(
                this.map.getView().getCenter(),
                this.map.getView().getZoom()
            )
        })
    }

    componentDidMount() {
        const mapTarget = ReactDOM.findDOMNode(this.refs.map)
        const map = this.map
        map.setTarget(mapTarget)
    }

    componentWillReceiveProps(nextProps) {
        const map = this.map
        map.getView().setZoom(nextProps.data.mapZoom)
        map.getView().setCenter(nextProps.data.mapCenter)
        map.updateSize()
        var nextState = {}
        if (''+nextProps.data.id !== ''+this.state.id) {
            nextState = Object.assign({}, nextProps.data)
        } else {
            nextState = {
                ...this.state,
                mapZoom: nextProps.caop ? nextProps.data.mapZoom : this.state.mapZoom,
                mapCenter: nextProps.caop ? nextProps.data.mapCenter : this.state.mapCenter,
                dicofre: nextProps.caop ? nextProps.caop.dicofre : this.state.dicofre,
                freguesia: nextProps.caop ? nextProps.caop.freguesia : this.state.freguesia,
                concelho: nextProps.caop ? nextProps.caop.concelho : this.state.concelho,
                distrito: nextProps.caop ? nextProps.caop.distrito : this.state.distrito
            }
        }
        nextState.user = nextState.user || this.props.auth.username
        this.setState(nextState)
    }

    updateForm(field, value) {
        const formData = this.state
        formData[field] = value
        this.setState(formData)
    }

    renderMap() {
        const mapTarget = ReactDOM.findDOMNode(this.refs.map)
        const updateMap = setInterval(() => {
            if (mapTarget.offsetHeight) {
                this.map.updateSize()
                return clearInterval(updateMap)
            }
        }, 50)
    }

    onChangeAddress(address) {
        this.props.gmapsGeocoder(address)
    }

    componentWillUnmount() {
        this.map.setTarget(null)
    }

    render() {
        return (
            <Row>
                <Col span={24}>
                    <form method="post" onSubmit={(e) => {
                        e.preventDefault()
                        this.props.storeItem(this.state)
                    }}>
                        <input type="hidden" ref="id" value={this.state.id} />

                        <Row>
                            <Col xs={24} sm={6}></Col>
                            <Col xs={24} sm={14}>
                                <legend>{this.state.id ? 'Alterar Ocorrência' : 'Criar Nova Ocorrência'}</legend>
                            </Col>
                        </Row>

                        <div className="ant-row ant-form-item">
                            <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                                <label htmlFor="title" className="ant-form-item-required" title="Título da Ocorrência">
                                    Título
                                </label>
                            </div>
                            <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14">
                                <input id="title"
                                    value={this.state.title}
                                    ref="title"
                                    className="ant-input"
                                    required={true}
                                    onChange={(e) => {this.updateForm('title', e.target.value)}}
                                />
                            </div>
                        </div>

                        <input type="hidden" name="user" value={this.state.user} />
                        <input type="hidden" name="entity" value={this.state.entity} />

                        <div className="ant-row ant-form-item">
                            <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                                <label htmlFor="status" className="ant-form-item-required" title="Perfil de Utilizador">
                                    Estado do Registo
                                </label>
                            </div>
                            <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14">
                                <Select value={''+this.state.status}
                                    onChange={(v) => this.updateForm('status', v)}>
                                    <Option key="1" value="Guardada">Guardada</Option>
                                    <Option key="2" value="Submetida">Submetida</Option>
                                </Select>
                            </div>
                        </div>

                        <div className="ant-row ant-form-item">
                            <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                                <label htmlFor="issuedate" className="ant-form-item-required" title="Data e Hora">
                                    Data | Hora da Ocorrência
                                </label>
                            </div>
                            <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14" id="issueDateWrapper">
                                <DatePicker defaultValue={moment(this.state.issue_date, dateFormat)} format={dateFormat}
                                    onChange={(date, dateStr) => {this.updateForm('issue_date', dateStr)}}
                                />
                            <TimePicker defaultValue={moment(this.state.issue_time, format)} format={format}
                                    onChange={(time, timeStr) => {this.updateForm('issue_time', timeStr)}}
                                />
                            </div>
                        </div>

                        <div className="ant-row ant-form-item">
                            <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                                <label htmlFor="recorddate" className="ant-form-item-required" title="Data e Hora">
                                    Data | Hora do Registo
                                </label>
                            </div>
                            <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14" id="issueDateWrapper">
                                <DatePicker defaultValue={moment(this.state.issue_reg_date, dateFormat)} format={dateFormat}
                                    onChange={(date, dateStr) => {this.updateForm('issue_reg_date', dateStr)}}
                                />
                            <TimePicker defaultValue={moment(this.state.issue_reg_time, format)} format={format}
                                    onChange={(time, timeStr) => {this.updateForm('issue_reg_time', timeStr)}}
                                />
                            </div>
                        </div>

                        <div className="ant-row ant-form-item">
                            <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                                <label htmlFor="issuedetection" className="ant-form-item-required" title="Deteção da Ocorrência">
                                    Deteção da Ocorrência
                                </label>
                            </div>
                            <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14" id="issueDetectionWrapper">
                                <RadioGroup value={this.state.issue_detection}
                                    onChange={(e) => {this.updateForm('issue_detection', e.target.value)}}>
                                    <Radio value={1}>Aviso/Chamada</Radio>
                                    <Radio value={2}>Visita Regular</Radio>
                                </RadioGroup>
                            </div>
                        </div>

                        <div className="ant-row ant-form-item">
                            <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                                <label htmlFor="address" className="ant-form-item-required" title="Localizar por endereço">Cidade / Morada</label>
                            </div>
                            <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14">
                                <Input ref="address"
                                    value={this.state.address}
                                    onChange={(e) => {this.updateForm('address', e.target.value)}}
                                    suffix={(<Button type="primary" onClick={(e) => this.onChangeAddress(this.state.address) }>
                                        <span className="hide-small">Centrar no Mapa</span>
                                        <span className="hide-medium">
                                            <Icon type="environment" />
                                        </span>
                                    </Button>)}
                                />
                            <div className="map" id="map" ref="map" style={{height: '280px', marginTop: '24px'}}></div>
                            </div>
                        </div>

                        <div className="ant-row ant-form-item">
                            <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                                <label htmlFor="freguesia" className="ant-form-item-required" title="Freguesia, Concelho e Distrito">Freguesia</label>
                            </div>
                            <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-6">
                                <Input ref="freguesia" value={this.state.freguesia}
                                    placeholder="Freguesia"
                                    onChange={(e) => this.updateForm('freguesia', e.target.value)}
                                />
                            </div>
                            <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-4">
                                <Input ref="concelho" value={this.state.concelho}
                                    placeholder="Concelho"
                                    onChange={(e) => this.updateForm('concelho', e.target.value)}
                                />
                            </div>
                            <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-4">
                                <Input ref="distrito" value={this.state.distrito}
                                    placeholder="Distrito"
                                    onChange={(e) => this.updateForm('distrito', e.target.value)}
                                />
                            </div>
                        </div>

                        <div className="ant-row ant-form-item">
                            <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                                <label htmlFor="praia" className="ant-form-item-required" title="Localizar por endereço">Praia <small>(se aplicável)</small></label>
                            </div>
                            <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14">
                                <Input ref="praia" value={this.state.praia || ''}
                                    onChange={(e) => this.updateForm('praia', e.target.value)}
                                />
                            </div>
                        </div>

                        <Row>
                            <Col xs={24} sm={6}></Col>
                            <Col xs={24} sm={14}><legend>Tipologia</legend></Col>
                        </Row>

                        <div className="ant-row ant-form-item">
                            <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6 hide-small">
                                <label htmlFor="issuedetection" className="ant-form-item-required" title="Deteção da Ocorrência">
                                    Tipologia da Ocorrência
                                </label>
                            </div>
                            <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14 issue-tree-wrapper">
                                <ol>
                                    <li>
                                        <strong>a.{'  '}
                                            <Checkbox checked={this.state.type_a}
                                                onChange={(e) => this.updateForm('type_a', e.target.checked)}>
                                                Instabilidade em arribas
                                            </Checkbox>
                                        </strong>
                                        <div style={{display: this.state.type_a ? 'block' : 'none'}}>
                                            <ol>
                                                <li>
                                                    <Checkbox checked={this.state.type_ai}
                                                        onChange={(e) => this.updateForm('type_ai', e.target.checked)}>
                                                        i. Movimento de massa de vertente (MMV)
                                                    </Checkbox>
                                                    <div>
                                                        <ol>
                                                            <li>
                                                                <span>Alcance máximo do depósito/detritos (m) </span>
                                                                <InputNumber min={0} max={9999}
                                                                    value={this.state.type_ai_meters}
                                                                    size="small"
                                                                    style={{marginBottom: '-6px'}}
                                                                    onChange={(v) => this.updateForm('type_ai_meters', v)} />
                                                            </li>
                                                        </ol>
                                                    </div>
                                                </li>
                                                <li>
                                                    <Checkbox checked={this.state.type_aii}
                                                        onChange={(e) => this.updateForm('type_aii', e.target.checked)}>
                                                        ii. Fenda de tração com cobertura visivel
                                                    </Checkbox>
                                                </li>
                                            </ol>
                                        </div>
                                    </li>
                                    <li>
                                        <strong>b.{'  '}
                                            <Checkbox checked={this.state.type_b}
                                                onChange={(e) => this.updateForm('type_b', e.target.checked)}>
                                                Erosão/recuo em arribas
                                            </Checkbox>
                                        </strong>
                                        <div style={{display: this.state.type_b ? 'block' : 'none'}}>
                                            <ol>
                                                <li>
                                                    <Checkbox checked={this.state.type_bi}
                                                        onChange={(e) => this.updateForm('type_bi', e.target.checked)}>
                                                        i. Escarpamento da duna
                                                    </Checkbox>
                                                    <div style={{display: this.state.type_bi ? 'block' : 'none'}}>
                                                        <ol>
                                                            <li>
                                                                <span>Altura máxima da escarpa (m) </span>
                                                                <InputNumber min={0} max={99}
                                                                    value={this.state.type_bi_meters}
                                                                    size="small"
                                                                    style={{marginBottom: '-6px'}}
                                                                    onChange={(v) => this.updateForm('type_bi_meters', v)}
                                                                />
                                                            </li>
                                                        </ol>
                                                    </div>
                                                </li>
                                                <li>
                                                    <Checkbox checked={this.state.type_bii}
                                                        onChange={(e) => this.updateForm('type_bii', e.target.checked)}>
                                                        ii. Rebaxamento da praia
                                                    </Checkbox>
                                                    <div style={{display: this.state.type_bii ? 'block' : 'none'}}>
                                                        <ol>
                                                            <li>
                                                                <span>Altura máxima (m) </span>
                                                                <InputNumber min={0} max={99}
                                                                    value={this.state.type_bii_meters}
                                                                    size="small"
                                                                    style={{marginBottom: '-6px'}}
                                                                    onChange={(v) => this.updateForm('type_bii_meters', v)}
                                                                />
                                                            </li>
                                                        </ol>
                                                    </div>
                                                </li>
                                            </ol>
                                        </div>
                                    </li>
                                    <li>
                                        <strong>c.{'  '}
                                            <Checkbox checked={this.state.type_c}
                                                onChange={(e) => this.updateForm('type_c', e.target.checked)}>
                                                Dano em obra/estrutura de proteção costeira
                                            </Checkbox>
                                        </strong>
                                    </li>
                                    <li><strong>d.{'  '}
                                            <Checkbox checked={this.state.type_d}
                                                onChange={(e) => this.updateForm('type_d', e.target.checked)}>
                                                Galgamento costeiro
                                            </Checkbox>
                                        </strong>
                                        <div style={{display: this.state.type_d ? 'block' : 'none'}}>
                                            <ol>
                                                <li>
                                                    <span>Alcance máximo da água/detritos (m) </span>
                                                    <InputNumber min={0} max={99}
                                                        value={this.state.type_d_meters}
                                                        size="small"
                                                        style={{marginBottom: '-6px'}}
                                                        onChange={(v) => this.updateForm('type_d_meters', v)}
                                                    />
                                                </li>
                                            </ol>
                                        </div>
                                    </li>
                                </ol>
                            </div>
                        </div>

                        <Row>
                            <Col xs={24} sm={6}></Col>
                            <Col xs={24} sm={14}><legend>Consequência(s) da Ocorrência</legend></Col>
                        </Row>

                        <div className="ant-row ant-form-item">
                            <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6 hide-small">
                                <label htmlFor="issuedetection" className="ant-form-item-required" title="Deteção da Ocorrência">
                                    Consequência(s) da Ocorrência
                                </label>
                            </div>
                            <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14 issue-tree-wrapper">
                                <ol>
                                    <li><strong>a. Pessoas em risco</strong>
                                        <div>
                                            <RadioGroup value={this.state.cons_a}
                                                onChange={(e) => {this.updateForm('cons_a', e.target.value)}}>
                                                <Radio value={'1'}>i. Não</Radio>
                                                <Radio value={'2'}>ii. Não sabe / Não aplicável</Radio>
                                                <Radio value={'3'}>iii. Sim</Radio>
                                            </RadioGroup>

                                            <div style={{display: this.state.cons_a === '3' ? 'block' : 'none'}}>
                                                <ol>
                                                    <li>
                                                        <Checkbox checked={this.state.cons_a === '3' && this.state.cons_aiii_qtt === 1}
                                                            onChange={(e) => this.updateForm('cons_aiii_qtt', e.target.checked ? 1 : null)}>
                                                            1 - 10
                                                        </Checkbox>
                                                        <Checkbox checked={this.state.cons_a === '3' && this.state.cons_aiii_qtt === 2}
                                                            onChange={(e) => this.updateForm('cons_aiii_qtt', e.target.checked ? 2 : null)}>
                                                            10 - 100
                                                        </Checkbox>
                                                        <Checkbox checked={this.state.cons_a === '3' && this.state.cons_aiii_qtt === 3}
                                                            onChange={(e) => this.updateForm('cons_aiii_qtt', e.target.checked ? 3 : null)}>
                                                            > 100
                                                        </Checkbox>
                                                    </li>
                                                </ol>
                                            </div>

                                        </div>
                                    </li>
                                    <li><strong>b. Danos em infra-estruturas</strong>
                                        <div>
                                            <ol>
                                                <li>
                                                    <Checkbox checked={this.state.cons_bi}
                                                        onChange={(e) => this.updateForm('cons_bi', e.target.checked)}>
                                                        i. Não
                                                    </Checkbox>
                                                </li>
                                                <li>
                                                    <Checkbox checked={this.state.cons_bii}
                                                        onChange={(e) => this.updateForm('cons_bii', e.target.checked)}>
                                                        ii. Estruturas de proteção/defesa costeira
                                                    </Checkbox>
                                                    <div style={{display: this.state.cons_bii ? 'block' : 'none'}}>
                                                        <ol>
                                                            <li>
                                                                <Checkbox checked={this.state.cons_bii1}
                                                                    onChange={(e) => this.updateForm('cons_bii1', e.target.checked)}>
                                                                    1. Estrutura aderente
                                                                </Checkbox>
                                                            </li>
                                                            <li>
                                                                <Checkbox checked={this.state.cons_bii2}
                                                                    onChange={(e) => this.updateForm('cons_bii2', e.target.checked)}>
                                                                    2. Esporão/quebra-mar
                                                                </Checkbox>
                                                            </li>
                                                            <li>
                                                                <Checkbox checked={this.state.cons_bii3}
                                                                    onChange={(e) => this.updateForm('cons_bii3', e.target.checked)}>
                                                                    3. Obra de proteção/estabilização de Arriba
                                                                </Checkbox>
                                                            </li>
                                                        </ol>
                                                    </div>
                                                </li>
                                                <li>
                                                    <Checkbox checked={this.state.cons_biii}
                                                        onChange={(e) => this.updateForm('cons_biii', e.target.checked)}>
                                                        iii. Áreas construídas de fruição/uso público
                                                    </Checkbox>
                                                    <ol>
                                                        <li>
                                                            (e.g. passeio pedonal/passadiços/miradouro/zonas estadia)
                                                        </li>
                                                    </ol>
                                                </li>
                                                <li>
                                                    <Checkbox checked={this.state.cons_biv}
                                                        onChange={(e) => this.updateForm('cons_biv', e.target.checked)}>
                                                        iv. Edificações
                                                    </Checkbox>
                                                    <ol>
                                                        <li>
                                                            (e.g. habitações/comerciais/apoios de praia)
                                                        </li>
                                                    </ol>
                                                </li>
                                            </ol>
                                        </div>
                                    </li>
                                </ol>
                            </div>
                        </div>

                        <Row>
                            <Col xs={24} sm={6}></Col>
                            <Col xs={24} sm={14}><legend>Medidas de mitigação ou minimização do risco</legend></Col>
                        </Row>

                        <div className="ant-row ant-form-item">
                            <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6 hide-small">
                                <label htmlFor="issuedetection" className="ant-form-item-required" title="Deteção da Ocorrência">
                                    Medidas de mitigação ou minimização do risco
                                </label>
                            </div>
                            <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14 issue-tree-wrapper">
                                <RadioGroup value={this.state.miti}
                                    onChange={(e) => {this.updateForm('miti', e.target.value)}}>
                                    <Radio value={'1'}>i. Não</Radio>
                                    <Radio value={'2'}>ii. Não sabe / Não aplicável</Radio>
                                    <Radio value={'3'}>iii. Sim</Radio>
                                </RadioGroup>

                                <div style={{display: this.state.miti === '3' ? 'block' : 'none'}}>
                                    <table style={{tableLayout: 'fixed', paddingTop: '40px'}}>
                                        <thead>
                                            <tr>
                                                <td></td>
                                                <td style={{width: '24px'}}><div className="vertical-text">Imediatas</div></td>
                                                <td style={{width: '24px'}}><div className="vertical-text">A adotar</div></td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    i. Sinalização (aviso/interdição)
                                                </td>
                                                <td>
                                                    <Checkbox checked={this.state.miti_c_i === 'i'}
                                                        onChange={(e) => this.updateForm('miti_c_i', e.target.checked ? 'i' : null)}></Checkbox>
                                                </td>
                                                <td>
                                                    <Checkbox checked={this.state.miti_c_i === 'a'}
                                                        onChange={(e) => this.updateForm('miti_c_i', e.target.checked ? 'a' : null)}></Checkbox>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    ii. Delimitação/interdição de área de risco
                                                </td>
                                                <td>
                                                    <Checkbox checked={this.state.miti_c_ii === 'i'}
                                                        onChange={(e) => this.updateForm('miti_c_ii', e.target.checked ? 'i' : null)}></Checkbox>
                                                </td>
                                                <td>
                                                    <Checkbox checked={this.state.miti_c_ii === 'a'}
                                                        onChange={(e) => this.updateForm('miti_c_ii', e.target.checked ? 'a' : null)}></Checkbox>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    iii. Saneamento de blocos/reperfilamento
                                                </td>
                                                <td>
                                                    <Checkbox checked={this.state.miti_c_iii === 'i'}
                                                        onChange={(e) => this.updateForm('miti_c_iii', e.target.checked ? 'i' : null)}></Checkbox>
                                                </td>
                                                <td>
                                                    <Checkbox checked={this.state.miti_c_iii === 'a'}
                                                        onChange={(e) => this.updateForm('miti_c_iii', e.target.checked ? 'a' : null)}></Checkbox>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    iv. Reabilitação de obra de proteção/estabilização
                                                </td>
                                                <td>
                                                    <Checkbox checked={this.state.miti_c_iv === 'i'}
                                                        onChange={(e) => this.updateForm('miti_c_iv', e.target.checked ? 'i' : null)}></Checkbox>
                                                </td>
                                                <td>
                                                    <Checkbox checked={this.state.miti_c_iv === 'a'}
                                                        onChange={(e) => this.updateForm('miti_c_iv', e.target.checked ? 'a' : null)}></Checkbox>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    v. Reforço/Alimentação artificial de emergência
                                                </td>
                                                <td>
                                                    <Checkbox checked={this.state.miti_c_v === 'i'}
                                                        onChange={(e) => this.updateForm('miti_c_v', e.target.checked ? 'i' : null)}></Checkbox>
                                                </td>
                                                <td>
                                                    <Checkbox checked={this.state.miti_c_v === 'a'}
                                                        onChange={(e) => this.updateForm('miti_c_v', e.target.checked ? 'a' : null)}></Checkbox>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                            </div>
                        </div>

                        <div className="ant-row ant-form-item">
                            <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                                <label htmlFor="description" className="ant-form-item-required" title="Observações da Ocorrência">Observações</label>
                            </div>
                            <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14">
                                <div className="ant-form-item-control ">
                                    <TextArea id="description" rows={6} value={this.state.obs}
                                        onChange={(e) => this.updateForm('obs', e.target.value)} />
                                </div>
                            </div>
                        </div>

                        <Row>
                            <Col xs={24} sm={6}></Col>
                            <Col xs={24} sm={14}><legend>Anexos</legend></Col>
                        </Row>

                        <div className="ant-row ant-form-item">
                            <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6 hide-small">
                                <label htmlFor="issuedetection" className="ant-form-item" title="Anexos">
                                    Tipos de Anexos
                                </label>
                            </div>
                            <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14 issue-tree-wrapper">
                                <ol>
                                    <li>
                                        <IssueUploadA {...this.state}  onChangeField={this.updateForm} />
                                    </li>
                                    <li>
                                        <IssueUploadB {...this.state}  onChangeField={this.updateForm} />
                                    </li>
                                    <li>
                                        <strong>c.{' '}
                                            <Checkbox checked={this.state.attach_c}
                                                onChange={(e) => this.updateForm('attach_c', e.target.checked)}>
                                                Levantamento topográfico
                                            </Checkbox>
                                        </strong>
                                        <div style={{display: this.state.attach_c ? 'block' : 'none'}}>
                                            <ol>
                                                <li>
                                                    <div>
                                                        <strong>i.{' '}
                                                            <Checkbox checked={this.state.attach_ci}
                                                                onChange={(e) => this.updateForm('attach_ci', e.target.checked)}>
                                                                Área integral ou parcial da praia
                                                            </Checkbox>
                                                        </strong>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div>
                                                        <strong>ii.{' '}
                                                            <Checkbox checked={this.state.attach_cii}
                                                                onChange={(e) => this.updateForm('attach_cii', e.target.checked)}>
                                                                Perfil de praia
                                                            </Checkbox>
                                                        </strong>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div>
                                                        <strong>iii.{' '}
                                                            <Checkbox checked={this.state.attach_ciii}
                                                                onChange={(e) => this.updateForm('attach_ciii', e.target.checked)}>
                                                                Base do cordão dunar/escarpa de erosão
                                                            </Checkbox>
                                                        </strong>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div>
                                                        <strong>iv.{' '}
                                                            <Checkbox checked={this.state.attach_civ}
                                                                onChange={(e) => this.updateForm('attach_civ', e.target.checked)}>
                                                                Obra de proteção/estabilização
                                                            </Checkbox>
                                                        </strong>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div>
                                                        <strong>v.{' '}
                                                            <Checkbox checked={this.state.attach_cv}
                                                                onChange={(e) => this.updateForm('attach_cv', e.target.checked)}>
                                                                Delimitação do MMV
                                                            </Checkbox>
                                                        </strong>
                                                    </div>
                                                </li>
                                            </ol>
                                            <IssueUploadC {...this.state} />
                                        </div>
                                    </li>
                                    <li>
                                        <IssueUploadD {...this.state} />
                                    </li>
                                </ol>
                            </div>
                        </div>

                        <Row>
                            <Col xs={24} sm={6}></Col>
                            <Col xs={24} sm={14}>
                                <Alert className={this.props.complete && this.props.error ? '' : 'hidden'}
                                    message="Erro"
                                    description={this.props.error}
                                    type="error"
                                    showIcon
                                />
                                <Alert className={this.props.complete && !this.props.error ? '' : 'hidden'}
                                    message="Sucesso!"
                                    description="A ocorrência foi guardada com sucesso."
                                    type="success"
                                    showIcon
                                />
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={24} sm={6}></Col>
                            <Col xs={24} sm={14}>
                                <div style={{borderTop: '2px solid gray', marginTop: '16px', paddingTop: '8px'}}>
                                    <button type="submit" className="ant-btn ant-btn-primary" style={{float: 'right'}}>
                                        <i className="anticon anticon-save"></i>
                                        <span>Guardar</span>
                                    </button>
                                    <Button type="danger" onClick={(e) => this.props.history.push('/admin/issues')}>
                                        Cancelar
                                    </Button>
                                </div>
                            </Col>
                        </Row>

                    </form>
                </Col>
            </Row>
        )
    }
}

export default AdminIssuesForm;



// WEBPACK FOOTER //
// ./src/components/AdminIssuesForm.js